import { ToursListing } from "../components/ToursListing";
import { IMAGES } from "../data/site";

export default function DomesticTours() {
  return (
    <ToursListing
      type="domestic"
      eyebrow="Incredible India"
      title="Domestic Tours"
      subtitle="From Himalayan passes to tropical islands and royal deserts — discover India with the people who know it best."
      image={IMAGES.himalaya}
    />
  );
}
